/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch } from '../fn/project-item-submittals/api-project-item-submittals-consultant-approve-or-reject-project-item-submittal-patch';
import { ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Params } from '../fn/project-item-submittals/api-project-item-submittals-consultant-approve-or-reject-project-item-submittal-patch';
import { apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain } from '../fn/project-item-submittals/api-project-item-submittals-consultant-approve-or-reject-project-item-submittal-patch-plain';
import { ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain$Params } from '../fn/project-item-submittals/api-project-item-submittals-consultant-approve-or-reject-project-item-submittal-patch-plain';
import { apiProjectItemSubmittalsCreateProjectItemSubmittalPost } from '../fn/project-item-submittals/api-project-item-submittals-create-project-item-submittal-post';
import { ApiProjectItemSubmittalsCreateProjectItemSubmittalPost$Params } from '../fn/project-item-submittals/api-project-item-submittals-create-project-item-submittal-post';
import { apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain } from '../fn/project-item-submittals/api-project-item-submittals-create-project-item-submittal-post-plain';
import { ApiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain$Params } from '../fn/project-item-submittals/api-project-item-submittals-create-project-item-submittal-post-plain';
import { apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete } from '../fn/project-item-submittals/api-project-item-submittals-delete-project-item-submittal-delete';
import { ApiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Params } from '../fn/project-item-submittals/api-project-item-submittals-delete-project-item-submittal-delete';
import { apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain } from '../fn/project-item-submittals/api-project-item-submittals-delete-project-item-submittal-delete-plain';
import { ApiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain$Params } from '../fn/project-item-submittals/api-project-item-submittals-delete-project-item-submittal-delete-plain';
import { apiProjectItemSubmittalsGetProjectItemSubmittalPost } from '../fn/project-item-submittals/api-project-item-submittals-get-project-item-submittal-post';
import { ApiProjectItemSubmittalsGetProjectItemSubmittalPost$Params } from '../fn/project-item-submittals/api-project-item-submittals-get-project-item-submittal-post';
import { apiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain } from '../fn/project-item-submittals/api-project-item-submittals-get-project-item-submittal-post-plain';
import { ApiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain$Params } from '../fn/project-item-submittals/api-project-item-submittals-get-project-item-submittal-post-plain';
import { apiProjectItemSubmittalsGetProjectItemSubmittalsPost } from '../fn/project-item-submittals/api-project-item-submittals-get-project-item-submittals-post';
import { ApiProjectItemSubmittalsGetProjectItemSubmittalsPost$Params } from '../fn/project-item-submittals/api-project-item-submittals-get-project-item-submittals-post';
import { apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain } from '../fn/project-item-submittals/api-project-item-submittals-get-project-item-submittals-post-plain';
import { ApiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain$Params } from '../fn/project-item-submittals/api-project-item-submittals-get-project-item-submittals-post-plain';
import { apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch } from '../fn/project-item-submittals/api-project-item-submittals-owner-approve-or-reject-project-item-submittal-patch';
import { ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Params } from '../fn/project-item-submittals/api-project-item-submittals-owner-approve-or-reject-project-item-submittal-patch';
import { apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain } from '../fn/project-item-submittals/api-project-item-submittals-owner-approve-or-reject-project-item-submittal-patch-plain';
import { ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain$Params } from '../fn/project-item-submittals/api-project-item-submittals-owner-approve-or-reject-project-item-submittal-patch-plain';
import { apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch } from '../fn/project-item-submittals/api-project-item-submittals-update-project-item-submittal-patch';
import { ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Params } from '../fn/project-item-submittals/api-project-item-submittals-update-project-item-submittal-patch';
import { apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain } from '../fn/project-item-submittals/api-project-item-submittals-update-project-item-submittal-patch-plain';
import { ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain$Params } from '../fn/project-item-submittals/api-project-item-submittals-update-project-item-submittal-patch-plain';
import { ApproveOrRejectProjectItemSubmittalCommandResult } from '../models/approve-or-reject-project-item-submittal-command-result';
import { CreateProjectItemSubmittalCommandResult } from '../models/create-project-item-submittal-command-result';
import { DeleteProjectItemSubmittalCommandResult } from '../models/delete-project-item-submittal-command-result';
import { GetProjectItemSubmittalQueryResult } from '../models/get-project-item-submittal-query-result';
import { GetProjectItemSubmittalsQueryResult } from '../models/get-project-item-submittals-query-result';
import { OwnerApproveOrRejectItemSubmittalCommandResult } from '../models/owner-approve-or-reject-item-submittal-command-result';
import { UpdateProjectItemSubmittalCommandResult } from '../models/update-project-item-submittal-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectItemSubmittalsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectItemSubmittalsCreateProjectItemSubmittalPost()` */
  static readonly ApiProjectItemSubmittalsCreateProjectItemSubmittalPostPath = '/api/ProjectItemSubmittals/CreateProjectItemSubmittal';

  /**
   * Creates a new project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain$Response(params?: ApiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain(params?: ApiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain$Params, context?: HttpContext): Observable<CreateProjectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectItemSubmittalCommandResult>): CreateProjectItemSubmittalCommandResult => r.body)
    );
  }

  /**
   * Creates a new project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsCreateProjectItemSubmittalPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Response(params?: ApiProjectItemSubmittalsCreateProjectItemSubmittalPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsCreateProjectItemSubmittalPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSubmittalsCreateProjectItemSubmittalPost(params?: ApiProjectItemSubmittalsCreateProjectItemSubmittalPost$Params, context?: HttpContext): Observable<CreateProjectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectItemSubmittalCommandResult>): CreateProjectItemSubmittalCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch()` */
  static readonly ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatchPath = '/api/ProjectItemSubmittals/UpdateProjectItemSubmittal';

  /**
   * Updates an existing project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain$Response(params?: ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain(params?: ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectItemSubmittalCommandResult>): UpdateProjectItemSubmittalCommandResult => r.body)
    );
  }

  /**
   * Updates an existing project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Response(params?: ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch(params?: ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Params, context?: HttpContext): Observable<UpdateProjectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectItemSubmittalCommandResult>): UpdateProjectItemSubmittalCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete()` */
  static readonly ApiProjectItemSubmittalsDeleteProjectItemSubmittalDeletePath = '/api/ProjectItemSubmittals/DeleteProjectItemSubmittal';

  /**
   * Deletes a project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain$Response(params?: ApiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain(params?: ApiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectItemSubmittalCommandResult>): DeleteProjectItemSubmittalCommandResult => r.body)
    );
  }

  /**
   * Deletes a project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Response(params?: ApiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete(params?: ApiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Params, context?: HttpContext): Observable<DeleteProjectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectItemSubmittalCommandResult>): DeleteProjectItemSubmittalCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch()` */
  static readonly ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatchPath = '/api/ProjectItemSubmittals/ConsultantApproveOrRejectProjectItemSubmittal';

  /**
   * Approves or rejects a project item submittal By Consultant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain$Response(params?: ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveOrRejectProjectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Approves or rejects a project item submittal By Consultant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain(params?: ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain$Params, context?: HttpContext): Observable<ApproveOrRejectProjectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveOrRejectProjectItemSubmittalCommandResult>): ApproveOrRejectProjectItemSubmittalCommandResult => r.body)
    );
  }

  /**
   * Approves or rejects a project item submittal By Consultant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Response(params?: ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveOrRejectProjectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Approves or rejects a project item submittal By Consultant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch(params?: ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Params, context?: HttpContext): Observable<ApproveOrRejectProjectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveOrRejectProjectItemSubmittalCommandResult>): ApproveOrRejectProjectItemSubmittalCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch()` */
  static readonly ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatchPath = '/api/ProjectItemSubmittals/OwnerApproveOrRejectProjectItemSubmittal';

  /**
   * Approves or rejects a project item submittal By Owner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain$Response(params?: ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OwnerApproveOrRejectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Approves or rejects a project item submittal By Owner.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain(params?: ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain$Params, context?: HttpContext): Observable<OwnerApproveOrRejectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OwnerApproveOrRejectItemSubmittalCommandResult>): OwnerApproveOrRejectItemSubmittalCommandResult => r.body)
    );
  }

  /**
   * Approves or rejects a project item submittal By Owner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Response(params?: ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<OwnerApproveOrRejectItemSubmittalCommandResult>> {
    return apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Approves or rejects a project item submittal By Owner.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch(params?: ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Params, context?: HttpContext): Observable<OwnerApproveOrRejectItemSubmittalCommandResult> {
    return this.apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OwnerApproveOrRejectItemSubmittalCommandResult>): OwnerApproveOrRejectItemSubmittalCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSubmittalsGetProjectItemSubmittalsPost()` */
  static readonly ApiProjectItemSubmittalsGetProjectItemSubmittalsPostPath = '/api/ProjectItemSubmittals/GetProjectItemSubmittals';

  /**
   * Retrieves a list of project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain$Response(params?: ApiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSubmittalsQueryResult>> {
    return apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a list of project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain(params?: ApiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain$Params, context?: HttpContext): Observable<GetProjectItemSubmittalsQueryResult> {
    return this.apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemSubmittalsQueryResult>): GetProjectItemSubmittalsQueryResult => r.body)
    );
  }

  /**
   * Retrieves a list of project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsGetProjectItemSubmittalsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Response(params?: ApiProjectItemSubmittalsGetProjectItemSubmittalsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSubmittalsQueryResult>> {
    return apiProjectItemSubmittalsGetProjectItemSubmittalsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a list of project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsGetProjectItemSubmittalsPost(params?: ApiProjectItemSubmittalsGetProjectItemSubmittalsPost$Params, context?: HttpContext): Observable<GetProjectItemSubmittalsQueryResult> {
    return this.apiProjectItemSubmittalsGetProjectItemSubmittalsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemSubmittalsQueryResult>): GetProjectItemSubmittalsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSubmittalsGetProjectItemSubmittalPost()` */
  static readonly ApiProjectItemSubmittalsGetProjectItemSubmittalPostPath = '/api/ProjectItemSubmittals/GetProjectItemSubmittal';

  /**
   * Retrieves a project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain$Response(params?: ApiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSubmittalQueryResult>> {
    return apiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain(params?: ApiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain$Params, context?: HttpContext): Observable<GetProjectItemSubmittalQueryResult> {
    return this.apiProjectItemSubmittalsGetProjectItemSubmittalPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemSubmittalQueryResult>): GetProjectItemSubmittalQueryResult => r.body)
    );
  }

  /**
   * Retrieves a project item submittal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSubmittalsGetProjectItemSubmittalPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsGetProjectItemSubmittalPost$Response(params?: ApiProjectItemSubmittalsGetProjectItemSubmittalPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSubmittalQueryResult>> {
    return apiProjectItemSubmittalsGetProjectItemSubmittalPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a project item submittal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSubmittalsGetProjectItemSubmittalPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSubmittalsGetProjectItemSubmittalPost(params?: ApiProjectItemSubmittalsGetProjectItemSubmittalPost$Params, context?: HttpContext): Observable<GetProjectItemSubmittalQueryResult> {
    return this.apiProjectItemSubmittalsGetProjectItemSubmittalPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemSubmittalQueryResult>): GetProjectItemSubmittalQueryResult => r.body)
    );
  }

}
